import { ChangeDetectionStrategy, Component } from '@angular/core';
import { WhitelabeledComponentKey } from '../../../../../whitelabel/whitelabel-component-types';
import { WhitelabeledComponent } from '../../../../whitelabel/components/whitelabeled-component/whitelabeled-component.component';
import { DefaultDashboardLayoutComponent } from './default-dashboard-layout/default-dashboard-layout.component';

@Component({
  selector: 'osp-dashboard-layout',
  standalone: true,
  imports: [WhitelabeledComponent],
  templateUrl: './dashboard-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardLayoutComponent {
  protected readonly WhitelabeledComponentKey = WhitelabeledComponentKey;
  protected readonly DefaultLayout = DefaultDashboardLayoutComponent;
}
